var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatientNoConsent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#FF8317"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.84091 4V7.88851C9.84091 8.30546 9.82008 8.72014 9.77841 9.13256C9.73674 9.54045 9.68182 9.9574 9.61364 10.3834H8.42045C8.35227 9.9574 8.29735 9.54045 8.25568 9.13256C8.21402 8.72014 8.19318 8.30546 8.19318 7.88851V4H9.84091ZM8 12.8375C8 12.6744 8.02462 12.5225 8.07386 12.3821C8.12689 12.2416 8.19697 12.1192 8.28409 12.015C8.375 11.9107 8.48106 11.8291 8.60227 11.7702C8.72348 11.7068 8.85606 11.6751 9 11.6751C9.14015 11.6751 9.27083 11.7068 9.39205 11.7702C9.51326 11.8291 9.61932 11.9107 9.71023 12.015C9.80114 12.1192 9.87121 12.2416 9.92045 12.3821C9.97348 12.5225 10 12.6744 10 12.8375C10 13.0007 9.97348 13.1548 9.92045 13.2998C9.87121 13.4403 9.80114 13.5627 9.71023 13.6669C9.61932 13.7711 9.51326 13.8527 9.39205 13.9116C9.27083 13.9705 9.14015 14 9 14C8.85606 14 8.72348 13.9705 8.60227 13.9116C8.48106 13.8527 8.375 13.7711 8.28409 13.6669C8.19697 13.5627 8.12689 13.4403 8.07386 13.2998C8.02462 13.1548 8 13.0007 8 12.8375Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientNoConsent);
export default __webpack_public_path__ + "static/media/patient-no-consent.67cd2ffbc5f0a03af4adc625a6e5dede.svg";
export { ForwardRef as ReactComponent };